/* cc-article-footer — native share sheet on touch devices (Tony
   2026-07-15: tapping the platform links on a phone opened the app
   WITHOUT the post — iOS/Android app-intercept drops the web intent's
   payload). On coarse-pointer devices with the Web Share API, any
   share button opens the OS share sheet carrying title + URL; desktop
   keeps the direct platform links. Init guard per DAWN_NOTES §10
   (duplicate <script src> tags execute twice). */
(() => {
  if (window.ccInitGuardArticleFooter) return;
  window.ccInitGuardArticleFooter = true;

  const coarse = window.matchMedia('(pointer: coarse)');

  document.addEventListener('click', (e) => {
    if (!navigator.share || !coarse.matches) return;
    const btn = e.target.closest('.cc-article-footer__share-btn');
    if (!btn) return;
    const row = btn.closest('.cc-article-footer__share');
    if (!row || !row.dataset.shareUrl) return;
    e.preventDefault();
    navigator
      .share({ title: row.dataset.shareTitle || document.title, url: row.dataset.shareUrl })
      .catch(() => {}); /* user closed the sheet — nothing to do */
  });
})();
